// @flow

export const ACTIONS = {
  DRIVER_EDIT_PROFILE: "DRIVER_EDIT_PROFILE",
  DRIVER_CONFIRM_INFO: "DRIVER_CONFIRM_INFO",
  DRIVER_CLICK_CABONLINE_ACADEMY: "DRIVER_CLICK_CABONLINE_ACADEMY",
  DRIVER_CLICK_ON_COURSE: "DRIVER_CLICK_ON_COURSE",
  DRIVER_CLICK_CREAT_ACCOUNT: "DRIVER_CLICK_CREAT_ACCOUNT",
  DRIVER_CLICK_CONTINUE: "DRIVER_CLICK_CONTINUE",
  DRIVER_CLICK_CONTINUE_TO_LOGIN: "DRIVER_CLICK_CONTINUE_TO_LOGIN",
  DRIVER_CLICK_SAVE_ACCOUNT: "DRIVER_CLICK_SAVE_ACCOUNT"
}
